module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-tokens-container"
  }, [_c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      disabled: _vm.loading
    }
  }, [_c('h1', [_vm._v("Endpoint Tokens")]), _vm._v(" "), _c('p', {
    staticClass: "description-text"
  }, [_vm._v("\n      Administrera tokens för övervakning, hälsokontroller och API-rapporter. Det kan maximalt finnas 3 aktiva tokens samtidigt.\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "add-token-section"
  }, [_c('h3', [_vm._v("Skapa ny token")]), _vm._v(" "), _c('form', {
    staticClass: "add-token-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createToken($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "token-name"
    }
  }, [_vm._v("Namn*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tokenName),
      expression: "tokenName"
    }],
    attrs: {
      "type": "text",
      "id": "token-name",
      "placeholder": "t.ex. Övervakningstjänst Prod",
      "required": ""
    },
    domProps: {
      "value": (_vm.tokenName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.tokenName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "submit",
      "disabled": _vm.activeCount >= 3
    }
  }, [_vm._v("\n          Skapa token " + _vm._s(_vm.activeCount >= 3 ? '(Max 3 aktiva)' : '') + "\n        ")])])]), _vm._v(" "), (_vm.createdTokenPlain) ? _c('div', {
    staticClass: "created-token-modal"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "token-value-box"
  }, [_c('code', [_vm._v(_vm._s(_vm.createdTokenPlain))]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.copyToken
    }
  }, [_vm._v("\n            " + _vm._s(_vm.copied ? 'Kopierad!' : 'Kopiera') + "\n          ")])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.createdTokenPlain = ''
      }
    }
  }, [_vm._v("Jag har sparat tokenen")])])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "tokens-list-section"
  }, [_c('h3', [_vm._v("Befintliga tokens (" + _vm._s(_vm.tokens.length) + ")")]), _vm._v(" "), _c('table', {
    staticClass: "tokens-table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.tokens), function(token) {
    return _c('tr', {
      key: token.id
    }, [_c('td', {
      staticClass: "name-cell"
    }, [_c('strong', [_vm._v(_vm._s(token.name))])]), _vm._v(" "), _c('td', [_c('code', {
      staticClass: "masked-token-code"
    }, [_vm._v(_vm._s(token.masked_token || '-'))])]), _vm._v(" "), _c('td', [(token.currently_valid) ? _c('span', {
      staticClass: "status-badge active"
    }, [_vm._v("Aktiv")]) : (token.is_expired) ? _c('span', {
      staticClass: "status-badge expired"
    }, [_vm._v("Utgången")]) : _c('span', {
      staticClass: "status-badge inactive"
    }, [_vm._v("Inaktiverad")])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v(_vm._s(token.request_count || 0))]), _vm._v(" st")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(token.expiry_date)))]), _vm._v(" "), _c('td', {
      staticClass: "ips-cell"
    }, [(token.accessed_ips && token.accessed_ips.length > 0) ? _c('div', _vm._l((token.accessed_ips), function(ip) {
      return _c('span', {
        key: ip,
        staticClass: "ip-tag"
      }, [_vm._v(_vm._s(ip))])
    }), 0) : _c('span', {
      staticClass: "text-muted"
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(token.created_at)))]), _vm._v(" "), _c('td', [(token.is_active) ? _c('button', {
      staticClass: "btn btn-delete",
      on: {
        "click": function($event) {
          return _vm.deactivateToken(token)
        }
      }
    }, [_vm._v("\n                Inaktivera\n              ")]) : _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("-")])])])
  }), _vm._v(" "), (_vm.tokens.length === 0) ? _c('tr', [_c('td', {
    staticClass: "empty-cell",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("Inga tokens hittades.")])]) : _vm._e()], 2)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Denna token visas "), _c('strong', [_vm._v("endast denna gång")]), _vm._v(". När du stänger rutan är den krypterad i databasen och kan inte visas igen.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Namn")]), _vm._v(" "), _c('th', [_vm._v("Token")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Anrop")]), _vm._v(" "), _c('th', [_vm._v("Giltig till")]), _vm._v(" "), _c('th', [_vm._v("Loggade IP-adresser")]), _vm._v(" "), _c('th', [_vm._v("Skapad")]), _vm._v(" "), _c('th', [_vm._v("Åtgärd")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28dd0f4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Tokens.vue
// module id = 942
// module chunks = 0